import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Ua = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("rect", { width: "21", height: "7", fill: "#235BAA" }),
    React.createElement("rect", { y: "7", width: "21", height: "7", fill: "#FDD700" })), 'Ua', { width: 21, height: 14, viewBox: '0 0 21 14' });
export default Ua;
